import { render } from "./FormDatosUsuario.vue?vue&type=template&id=0f3ef997"
import script from "./FormDatosUsuario.vue?vue&type=script&lang=js"
export * from "./FormDatosUsuario.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__